import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Box,
  Center,
  Heading,
  HStack,
  Spacer,
  Spinner,
  Text,
  VStack,
} from "native-base";
import { Helmet } from "react-helmet-async";
import { RiFolderWarningLine } from "react-icons/ri";
import { FaPlusCircle } from "react-icons/fa";
import colors from "../../constants/colors";
import API from "../../api";
import { StateContext, StatusContext } from "../../contexts";
import Quotation from "../../components/quotation";
import { Link } from "react-router-dom";
import routes from "../../routes";

function QuotationsPage() {
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [quotations, setQuotations] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getQuotations = useCallback(async () => {
    try {
      setIsLoading(true);
      const {
        data: {
          data,
          meta: { total: _total },
        },
      } = await API(state.jwt).get("/quotations/user");
      setTotal(_total);
      setQuotations(data);
    } catch (error) {
      status.updateErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  }, [state.jwt, status]);

  useEffect(() => {
    getQuotations();
  }, [getQuotations]);

  return (
    <VStack paddingX={5} zIndex={1}>
      <Helmet>
        <title>Cotizaciones</title>
      </Helmet>
      <HStack paddingTop={8}>
        <Heading color={colors.secondary} fontSize="2xl">
          Cotizaciones
        </Heading>
      </HStack>
      <Text fontSize="sm" textAlign="right">
        Se han encontrado {total} resultado{total !== 1 && "s"}
      </Text>
      <Spacer height={5} />
      <HStack flexWrap="wrap" style={{ rowGap: 20, columnGap: 5 }}>
        {isLoading ? (
          <Center height={300} width="full">
            <Spinner size="lg" color={colors.primary} />
          </Center>
        ) : quotations.length ? (
          quotations.map((quotation) => (
            <Quotation key={quotation.id} quotation={quotation} role="user" />
          ))
        ) : (
          <Center height={300} width="full">
            <VStack alignItems="center" marginBottom={5}>
              <RiFolderWarningLine color={colors.secondary} fontSize={100} />
              <Text color={colors.secondary}>
                No hay información disponible
              </Text>
            </VStack>
            <Link to={routes.experienceCreation}>
              <Box
                backgroundColor={colors.primary}
                borderRadius="full"
                paddingX={10}
                paddingY={1}>
                <Text color={colors.white}>
                  Cotiza tu renta de autobus aquí
                </Text>
              </Box>
            </Link>
          </Center>
        )}
        {!!quotations.length && (
          <Link to={routes.experienceCreation}>
            <VStack
              alignItems="center"
              padding={6}
              backgroundColor="white"
              borderRadius={5}
              space={5}
              minWidth={200}
              maxWidth={300}
              width="full"
              shadow="1">
              <FaPlusCircle color={colors.secondary} size={40} />
              <Text color={colors.secondary}>Nueva cotización</Text>
            </VStack>
          </Link>
        )}
      </HStack>
      <Spacer height={10} />
    </VStack>
  );
}

export default QuotationsPage;
